import { IEvent } from "@services/event.services";
import { PlotService } from "@services/plot.service";
import { VeriDate } from "@services/veriDate.service";
import * as angular from "angular";
import * as moment from "moment";
import "./fleetEventDetails.component.scss";

interface IComponentBindings {
    event: IEvent;
}

class FleetEventBarComponentController implements angular.IComponentController, IComponentBindings {

    event: IEvent;

    static $inject = ["$q", "veriDate", "plotService"];

    constructor(
        private readonly $q: angular.IQService,
        private readonly veriDate: VeriDate,
        private readonly plotService: PlotService) { }

    $onInit(): void {
        this.processEvent();
    }

    $onChanges(onChangesObj: angular.IOnChangesObject): void {
        this.processEvent();
    }

    // ---

    private processEvent(): void {
        if (!event) {
            return;
        }

        const startMoment: moment.Moment = this.veriDate.createMoment(this.event.StartTime);
        const endMoment: moment.Moment = this.veriDate.createMoment(this.event.EndTime);
        const duration: moment.Duration = moment.duration(endMoment.diff(startMoment));

        this.event.duration = moment.utc(duration.asMilliseconds()).format('HH:mm:ss');

        this.updateEventPlots();
    }

    private updateEventPlots(): angular.IPromise<any> {
        const startPlotPromise = this.plotService.getPlot(this.event.VehicleId, this.event.StartPlotId).then(plot => {
            this.event.startPlot = plot;
        });

        const endPlotPromise = this.plotService.getPlot(this.event.VehicleId, this.event.EndPlotId).then(plot => {
            this.event.endPlot = plot;
        });

        return this.$q.all([startPlotPromise, endPlotPromise]);
    }
}

export class FleetEventDetailsComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;

    constructor() {
        this.bindings = {
            event: "<?"
        };

        this.controller = FleetEventBarComponentController;
        this.template = require("./fleetEventDetails.component.html");
    }
}
